import LoadingPage from 'my-components/LoadingPage';

import StudentCoursePageActivity from './StudentCoursePageActivity';
import StudentCoursePageNotFound from './StudentCoursePageNotFound';
import StudentCoursePagePracticeMode from './StudentCoursePagePracticeMode';

export default function StudentCoursePageOnDemand({
  activeComponent,
  classPass,
  course,
  currentUser,
  drawerOpen,
  fetching,
  fetchStatus,
  onToggleDrawer,
  pathMatchData,
  practiceMode,
  studySessions,
}) {
  if (fetching) {
    return <LoadingPage />;
  }
  if (!activeComponent)
    return <StudentCoursePageNotFound course={course} drawerOpen={drawerOpen} onToggleDrawer={onToggleDrawer} />;
  const Component = practiceMode ? StudentCoursePagePracticeMode : StudentCoursePageActivity;
  return (
    <Component
      activeComponent={activeComponent}
      classPassId={classPass?.id}
      course={course}
      currentUser={currentUser}
      drawerOpen={drawerOpen}
      fetchStatus={fetchStatus}
      onToggleDrawer={onToggleDrawer}
      pathMatchData={pathMatchData}
      studySessions={studySessions}
    />
  );
}
